export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBXCBOYuJlxZNq_SHJ8rlJniQx3RRIr_kI',
    authDomain: 'borgmenz.firebaseapp.com',
    databaseURL: 'https://borgmenz.firebaseio.com',
    projectId: 'borgmenz',
    storageBucket: 'borgmenz.appspot.com',
    messagingSenderId: '503802146597',
    appId: '1:503802146597:web:4070a6b7902939b348f4cc',
    measurementId: 'G-2SGWFJQ7YP',
  },
};
